import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import _ from 'underscore';

import {
  Tabs,
  Tab,
  withStyles,
} from '@material-ui/core';

import {getAgencies, getRides} from 'ondemand/selectors';
import {fetchAgenciesIfNeeded} from 'ondemand/actions/agency';
import {fetchRidesIfNeeded} from 'ondemand/actions/ride';
import PageLayout from 'ondemand/components/PageLayout';
import RideList from 'ondemand/components/RideList';
import messages from 'ondemand/messages.json';

const TABS = {
  CURRENT_RIDES: 'current',
  PAST_RIDES: 'past',
};

const styles = () => ({
  containerStyle: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  tabContainerStyle: {
    flex: 0,
  },
  rideListContainerStyle: {
    flex: 1,
    height: '100%',
    overflow: 'auto',
    paddingTop: 16,
  },
});

class MyRidesPage extends React.Component {
  static displayName = 'MyRidesPage';

  static propTypes = {
    agencies: PropTypes.object,
    dispatch: PropTypes.func,
    rides: PropTypes.array,
    route: PropTypes.object,
    classes: PropTypes.object,
  };

  state = {
    activeTab: TABS.CURRENT_RIDES,
  };

  componentDidMount() {
    this.props.dispatch(fetchAgenciesIfNeeded());
    this.props.dispatch(fetchRidesIfNeeded());
  }

  render() {
    if (this.props.rides === null || _.isEmpty(this.props.agencies)) {
      return null;
    }

    let emptyMessage = null;
    let rides = _.sortBy(this.props.rides, ride => ride.pickup.time);
    if (!_.size(rides)) {
      emptyMessage = messages.userHasNoRides;
    } else if (this.state.activeTab === TABS.CURRENT_RIDES) {
      rides = _.filter(rides, 'isActive');
      emptyMessage = messages.userHasNoCurrentRides;
    } else if (this.state.activeTab === TABS.PAST_RIDES) {
      rides = _.reject(rides, 'isActive');
      rides.reverse();  // Show most recent rides first.
      emptyMessage = messages.userHasNoPastRides;
    }

    return (
      <PageLayout dataId={'rides-page-container'} title="My Rides">
        <div className={this.props.classes.containerStyle}>
          <div data-id={'tabs-container'} className={this.props.classes.tabContainerStyle}>
            <Tabs
              variant="fullWidth"
              indicatorColor="primary"
              textColor="primary"
              value={this.state.activeTab}
            >
              <Tab
                data-id={'upcoming'}
                label="UPCOMING"
                value={TABS.CURRENT_RIDES}
                onClick={() => this.setState({activeTab: TABS.CURRENT_RIDES})}
              />
              <Tab
                data-id={'upcoming'}
                label="PAST"
                value={TABS.PAST_RIDES}
                onClick={() => this.setState({activeTab: TABS.PAST_RIDES})}
              />
            </Tabs>
          </div>
          <div className={this.props.classes.rideListContainerStyle}>
            <RideList
              agencies={this.props.agencies}
              dataId={'ride-list-container'}
              emptyMessage={emptyMessage}
              onClick={(ride) => this.props.dispatch(push(`/rides/${ride.rideId}`))}
              rides={rides}
            />
          </div>
        </div>
      </PageLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  agencies: getAgencies(state),
  rides: _.values(getRides(state)),
});

export default withStyles(styles)(connect(mapStateToProps)(MyRidesPage));



// WEBPACK FOOTER //
// ./src/ondemand/containers/MyRidesPage.js